import Vue from 'vue'
import Vuex, { MutationTree } from 'vuex'
import { Project } from '../types'
import projects from './projects'
import speaking from './speaking'
import mentorship from './mentorship'

Vue.use(Vuex)

interface RootState {
  currentProject: Project | undefined
  projects: Project[]
  speaking: Project[]
  mentorship: Project[]
}

export const SET_PROJECT = 'SET_PROJECT'

export const mutations: MutationTree<RootState> = {
  [SET_PROJECT](state, project: Project) {
    state.currentProject = project
  }
}

export default new Vuex.Store<RootState>({
  state: { currentProject: undefined, projects, speaking, mentorship },
  mutations,
  actions: {}
})
